const splitFileName = (fileName = '') => {
  const lastDotIndex = fileName.lastIndexOf('.');

  if (lastDotIndex <= 0) {
    return { stem: fileName, extension: '' };
  }

  return {
    stem: fileName.slice(0, lastDotIndex),
    extension: fileName.slice(lastDotIndex),
  };
};

export const buildSafeUploadFileName = (fileName = '') => {
  const { stem, extension } = splitFileName(fileName);
  const asciiStem = stem.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  const safeStem = asciiStem
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '') || 'archivo';
  const safeExtension = extension
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9.]+/g, '');

  return `${safeStem}${safeExtension}`;
};
